module.exports = __webpack_public_path__ + "static/teach-e74bfc088a29432cb7a87a015915c657.jpg";